<template>
  <div :class="langFlag ?'enPage':''">
    <div :class="bgFlag?'tarnsf':''">
      <div class="iheader"
           :class="moveFlag?'bgColor':''">
        <h1 class="ihed_h1">
          <img src="~@/assets/images/svg/logo_top_black.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="!bgFlag" />
          <img src="~@/assets/images/svg/logo_top_white.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="bgFlag" />
        </h1>
        <div class="herg">
          <span class="herg_lang"
                @click='changeLang()'>{{lang}}</span>
          <i class="herg_mu"
             @click="nuneClick(1)"></i>
        </div>
      </div>
    </div>
    <div class="hdplace"></div>
    <div class="imageList">

      <div class="bread"></div>
      <div class="abus">
        <div class="abusTp">
          <p class="ab_na fontS">{{langFlag ?'Our Studio':'关于合恣' }}</p>
          <div class="ab_per"
               :class="perFlag ?'active':''"
               @click="per()"></div>
          <div class="ab_next"
               :class="nextFlag ?'active':''"
               @click="next()"></div>
          <div class="abswnr clearfix">
            <div class="abswnr_rg"
                 v-html="aboutInfo.value">
              <!-- <p class="abswnr_rg_p ">合恣设计HEZI DESIGN是一个倡导在设计过程中建立“高尔夫规则”的国
                际化设计事务所，致力于联合设计师 及委托方，实现简单、公平、积极、共
                享、贡献的项目环境。
              </p>
              <p class="abswnr_rg_p ">创始人陈亨寰，以简约的设计语言解构复杂多样的空间形态，近30年设计
                经验与生活阅历，为每一项设计注 入不一样的灵魂。陈亨寰及团队的多
                样化设计项目，以人为本，构建出“15分钟生活半径”内丰富的生活场 景，
                以“富有情绪感染力”的人文主义视角，于平实简雅中展开设计图卷。作品
                屡获国内外设计大奖，如IAI全 球设计奖、艾特奖、德国红点设计奖等。</p> -->

            </div>
            <div class="abswnr_lf">
              <!-- swiper begin -->
              <div class="swiper-container ab_swiper swiper-no-swiping">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"
                       v-for="(item,index) in aboutInfo.data"
                       :key="'ab' +index">
                    <div class="abswnr_int">
                      <img :src="item"
                           class="ab_img" />
                    </div>
                  </div>
                  <!-- <div class="swiper-slide">
                    <div class="abswnr_int">
                      <img src="~@/assets/images/ab_img1.jpg"
                           class="ab_img" />
                    </div>
                  </div> -->
                </div>
                <!-- 如果需要分页器 -->
                <!-- <div class="swiper-pagination"></div> -->

                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
              <!-- swiper end -->
            </div>
          </div>

          <!-- swiper begin -->
          <!-- <div class="swiper-container ab_swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="abswnr clearfix">
                <div class="abswnr_rg">
                  <p class="abswnr_rg_p">合恣设计HEZI DESIGN是一个倡导在设计过程中建立“高尔夫规则”的国
                    际化设计事务所，致力于联合设计师 及委托方，实现简单、公平、积极、共
                    享、贡献的项目环境。
                  </p>
                  <p class="abswnr_rg_p">创始人陈亨寰，以简约的设计语言解构复杂多样的空间形态，近30年设计
                    经验与生活阅历，为每一项设计注 入不一样的灵魂。陈亨寰及团队的多
                    样化设计项目，以人为本，构建出“15分钟生活半径”内丰富的生活场 景，
                    以“富有情绪感染力”的人文主义视角，于平实简雅中展开设计图卷。作品
                    屡获国内外设计大奖，如IAI全 球设计奖、艾特奖、德国红点设计奖等。</p>
                </div>
                <div class="abswnr_lf">
                  <img src="~@/assets/images/ab_img1.jpg"
                       class="ab_img" />
                </div>
              </div>

            </div>

          </div>

          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div> -->
          <!-- swiper end -->
        </div>
        <div class="fwbk">
          <p class="ab_na fontS">{{langFlag ?'Service':'服务板块' }}</p>
          <div class="abswnr clearfix">
            <div class="abswnr_rg "
                 v-html="service.value">
              <!-- <p class="abswnr_rg_p ">以设计构建生活方式图景，涵盖居住生活、消费体验、娱乐休闲、社会活动
                等丰富 多样的空间形态，关注空间生长过程中的功能合理性与工艺质
                感，将泛居住类空间、公共社区建筑、文化教 育场所、品质美学中心等项
                目赋予恰如其分的美学观点与设计表达。</p>
              <p class="abswnr_rg_p4 "><span class="jd_sn">酒店设计</span> ‒ 营销中心、酒店等</p>
              <p class="abswnr_rg_p4 "><span class="jd_sn">商业设计</span> ‒ 社区建筑、书店、美术馆、 办公室等</p>
              <p class="abswnr_rg_p4 "><span class="jd_sn">住宅设计</span> ‒ 样板间、私宅等</p> -->
            </div>
            <!-- <div class="abswnr_rg ywPage">
              <p class="abswnr_rg_p ">Having worked with home owners, designers and architects for the
                last ten years one thing has became clear. It is very difficult for the
                consumer to decipher a good quality product from poor. Knowing
                this we decided that our business model would be based around
                compiling a group of the best performing products for the consumer
                eliminating the risk of bad product choice and disappointment.
              </p>
              <p class="abswnr_rg_p4 "><span class="jd_sn">Commercia</span> ‒ Office, Bookstore, Gallery, Public Space</p>
              <p class="abswnr_rg_p4 "><span class="jd_sn">Hotel & Resort</span> ‒ Amenities, Room Interior, Restaurant</p>
              <p class="abswnr_rg_p4 "><span class="jd_sn">Residential</span> ‒ Sale Center, Sample House, Private House</p>
            </div> -->
            <div class="abswnr_lf">
              <img src="~@/assets/images/ab_img2.jpg"
                   class="ab_img"
                   v-for="(item,index) in service.data"
                   :key="'sv' +index" />
              <!-- <img src="~@/assets/images/ab_img2.jpg"
                   class="ab_img" /> -->
            </div>
          </div>
        </div>
        <div class="hztd">
          <div class="hztd_in">
            <p class="ab_na fontS">{{langFlag ?'Hezi Team':'合恣团队' }}</p>
            <div class="abswnr clearfix">
              <div class="abswnr_rg"
                   v-html="team.value">
                <!-- <p class="abswnr_rg_p ">全球化背景、专业化设计、创造力表达，合恣设计以“合恣村，一个设计乌
                  托邦”为愿景，为团队打造实践理想主义的创作环境，聚集志同道合者赋
                  能合恣设计的品牌。</p> -->
                <!-- <p class="abswnr_rg_p ywPage">Hezi unites a community of designers, writers, artists, artisans, architects and creative minds whose work engages with slowness
                  toward a resetting of values in hospitality and beyond.</p> -->
              </div>
            </div>
          </div>
          <div class="hztdRw clearfix">
            <div class="hztdRw_li"
                 v-for="(item,index) in team.data"
                 :key="'tm' +index">
              <img :src="item.pic"
                   class="rw_img" />
              <p class="hztdRw_li_p1 ">{{item.name}}</p>
              <p class="hztdRw_li_p2 ">{{item.job}}</p>
            </div>
            <!-- <div class="hztdRw_li">
              <img src="~@/assets/images/rw_img1.jpg"
                   class="rw_img" />
              <p class="hztdRw_li_p1 zwPage">陈亨寰 Calvin</p>
              <p class="hztdRw_li_p2 zwPage">合恣设计创始人 & 合伙人</p>
              <p class="hztdRw_li_p1 ywPage">CALVIN CHEN</p>
              <p class="hztdRw_li_p2 ywPage">FOUNDER & PARTNER</p>
            </div>
            <div class="hztdRw_li">
              <img src="~@/assets/images/rw_img2.jpg"
                   class="rw_img" />
              <p class="hztdRw_li_p1 zwPage">李巍 Amy</p>
              <p class="hztdRw_li_p2 zwPage">合伙人 & 商务代表</p>
              <p class="hztdRw_li_p1 ywPage">AMY LI</p>
              <p class="hztdRw_li_p2 ywPage">PARTNER & HEAD OF BUSINESS</p>
            </div>
            <div class="hztdRw_li">
              <img src="~@/assets/images/rw_img3.jpg"
                   class="rw_img" />
              <p class="hztdRw_li_p1 zwPage">张三巧 Zakia</p>
              <p class="hztdRw_li_p2 zwPage">合伙人</p>
              <p class="hztdRw_li_p1 ywPage">ZAKIA CHANG</p>
              <p class="hztdRw_li_p2 ywPage">PARTNER</p>
            </div>
            <div class="hztdRw_li">
              <img src="~@/assets/images/rw_img4.jpg"
                   class="rw_img" />
              <p class="hztdRw_li_p1 zwPage">付志鹏 Foo</p>
              <p class="hztdRw_li_p2 zwPage">合伙人</p>
              <p class="hztdRw_li_p1 ywPage">FOO FU</p>
              <p class="hztdRw_li_p2 ywPage">PARTNER</p>
            </div>
            <div class="hztdRw_li">
              <img src="~@/assets/images/rw_img5.jpg"
                   class="rw_img" />
              <p class="hztdRw_li_p1 zwPage">田忠林 Lien Tian</p>
              <p class="hztdRw_li_p2 zwPage">合伙人</p>
              <p class="hztdRw_li_p1 ywPage">LIEN TIAN</p>
              <p class="hztdRw_li_p2 ywPage">PARTNER</p>
            </div>
            <div class="hztdRw_li">
              <img src="~@/assets/images/rw_img6.jpg"
                   class="rw_img" />
              <p class="hztdRw_li_p1 zwPage">陈学近 Kevin</p>
              <p class="hztdRw_li_p2 zwPage">合伙人</p>
              <p class="hztdRw_li_p1 ywPage">JOHN CHEN</p>
              <p class="hztdRw_li_p2 ywPage">PARTNER</p>
            </div> -->

          </div>

        </div>
        <div class="hztd">
          <div class="hztd_in">
            <p class="ab_na fontS">{{langFlag ?'Awards':'获奖经历' }}</p>
            <div class="abshjjl clearfix">
              <div class="abhj_rg">

                <div class="hj_li "
                     :class="'hj_li' + (index+1)"
                     v-for="(item,index) in award.data"
                     :key="'aw' +index">
                  <img :src="item"
                       class="jp_ico1" />
                </div>
                <!-- <div class="hj_li hj_li2">
                  <img src="~@/assets/images/jp_ico2.jpg"
                       class="jp_ico2" />
                </div>
                <div class="hj_li hj_li3">
                  <img src="~@/assets/images/jp_ico3.jpg"
                       class="jp_ico3" />
                </div>
                <div class="hj_li hj_li4">
                  <img src="~@/assets/images/jp_ico4.jpg"
                       class="jp_ico4" />
                </div>
                <div class="hj_li hj_li5">
                  <img src="~@/assets/images/jp_ico5.jpg"
                       class="jp_ico5" />
                </div>
                <div class="hj_li hj_li6">
                  <img src="~@/assets/images/jp_ico6.jpg"
                       class="jp_ico6" />
                </div>
                <div class="hj_li hj_li7">
                  <img src="~@/assets/images/jp_ico7.jpg"
                       class="jp_ico7" />
                </div>
                <div class="hj_li hj_li8">
                  <img src="~@/assets/images/jp_ico8.jpg"
                       class="jp_ico8" />
                </div>
                <div class="hj_li hj_li9">
                  <img src="~@/assets/images/jp_ico9.jpg"
                       class="jp_ico9" />
                </div>
                <div class="hj_li hj_li10">
                  <img src="~@/assets/images/jp_ico10.jpg"
                       class="jp_ico10" />
                </div>
                <div class="hj_li hj_li11">
                  <img src="~@/assets/images/jp_ico11.jpg"
                       class="jp_ico11" />
                </div> -->
              </div>
            </div>
          </div>

        </div>
        <div class="thedo">
          <p class="thedo_p">THE MORE WE DO</p>
          <p class="thedo_p">THE MORE WE CAN DO</p>
          <p class="thedo_p1">— 威廉·赫兹利特 </p>
        </div>
        <gotop></gotop>
      </div>
      <!-- footer -->
      <foot @contact="contact"></foot>
      <transition name="slide-fade">
        <munePage v-show="muneFlag"
                  :muneFlag="muneFlag"
                  :muneIndex="muneIndex"
                  @closeMu="closeMu"
                  @muneChange='muneIndexChange'></munePage>
      </transition>
    </div>
  </div>

</template>

<script>
import Swiper from 'swiper'
// import 'swiper/dist/css/swiper.min.css'
// import 'swiper/dist/js/swiper.min.js'
import { WOW } from 'wowjs'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import munePage from '@/pages/munePage.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      bgFlag: false,
      mySwiper: null,
      nextFlag: false,
      perFlag: true,
      muneFlag: false,
      muneIndex: 0,
      moveFlag: false,
      award: {},
      service: {},
      aboutInfo: {},
      team: {},
      contTit: '关于合恣',
    }
  },
  components: { foot, gotop, munePage },
  mounted() {
    document.title = this.contTit
    this.about()
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      })
      wow.init()
    })

    let that = this

    // 滚动条滚动
    window.addEventListener('scroll', this.handleScroll)
  },
  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      this.about()
      if (val) {
        this.contTit = 'about us'
        document.title = this.contTit
      } else {
        this.contTit = '关于合恣'
        document.title = this.contTit
      }
    },
  },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },
  methods: {
    next() {
      this.mySwiper.slideNext()
      // alert(this.mySwiper.activeIndex)
      if (this.mySwiper.activeIndex == 1) {
        this.nextFlag = true
        this.perFlag = false
      }
      console.log(this.nextFlag, this.perFlag)
    },
    per() {
      this.mySwiper.slidePrev()
      // alert(this.mySwiper.activeIndex)
      if (this.mySwiper.activeIndex == 0) {
        this.nextFlag = false
        this.perFlag = true
      }
      console.log(this.nextFlag, this.perFlag)
    },

    // 菜单
    nuneClick(index) {
      this.muneFlag = true
      this.muneIndex = 0
    },
    closeMu() {
      this.muneFlag = false
    },
    contact() {
      this.muneFlag = true
      this.muneIndex = 3
    },
    muneIndexChange(index) {
      this.muneIndex = index
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight
      var scroll = scrollTop - this.i
      this.i = scrollTop
      if (scroll <= 0) {
        this.moveFlag = false
      } else {
        this.moveFlag = true
      }
      if (scrollTop < winH) {
        this.bgFlag = false
      } else {
        this.bgFlag = true
      }

      // let t1 = document.documentElement.scrollTop || document.body.scrollTop
      // if (t1 > 10) {
      //   this.moveFlag = true
      // } else {
      //   this.moveFlag = false
      // }
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },

    // 返回首页
    toHome() {
      this.$router.push({
        name: 'home',
        // query: {
        //   type: type,
        // },
      })
    },

    // 关于我们
    about() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'about',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            that.team = response.data.team
            that.award = response.data.award
            that.service = response.data.service
            that.aboutInfo = response.data.about

            that.$nextTick(function () {
              that.mySwiper = new Swiper('.ab_swiper', {
                observer: true,
                observeParents: true,
                speed: 800,
                slidesPerView: 1,
                centeredSlides: true,
                // loop: true,
                // autoplay: {
                //   delay: 3000,
                //   disableOnInteraction: false,
                // },
                // loop: true,
                // pagination: {
                //   el: '.swiper-pagination',
                // },
                navigation: {
                  nextEl: '.ab_swiper .swiper-button-next',
                  prevEl: '.ab_swiper .swiper-button-prev',
                },
              })
            })
          }
        })
        .catch(function (error) {})
    },
  },
}
</script>






// WEBPACK FOOTER //
// src/pages/aboutUs.vue